import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserService} from "projects/nter-ui-kit/src/lib/framework/security/service/user.service";
import {NavigationUtilsService} from "projects/nter-ui-kit/src/lib/framework/util/service/navigation-utils.service";
import {AuthenticationService} from "@ui-kit/security/service/authentication.service";
import {AppConfigService} from "@ui-kit/config/app-config.service";
import {AdminContextService} from "@app/security/admin-context.service";

@Injectable({
  providedIn: 'root',
})
export class AdminAuthenticationService extends AuthenticationService {

  constructor(
    http: HttpClient,
    contextService: AdminContextService,
    userService: UserService,
    utilsService: NavigationUtilsService,
    config: AppConfigService) {
    super(http, contextService, userService, utilsService, config);
  }
}
